import { createContext } from 'react';

export const BreakpointContext = createContext('xs');

export const BreakpointProvider = BreakpointContext.Provider;
export const BreakpointConsumer = BreakpointContext.Consumer;
